import { combineReducers } from 'redux';

import authenticate from './authenticate/reducers';
import checks from './list/reducers';
import runChecks from './list/reducers';
import counters from './counter/reducers';
import users from './users/reducers';
import suspiciousProfiles from './suspiciousProfiles/reducers';
import profileChecks from './profileChecks/reducers';
import flash from './flash/reducers';
import profileVerifications from './verification/reducers';
import checkVerifications from './verification/reducers';
import singleChecks from './singleCheck/reducers';
import storage from './storage/reducers';
import userHistories from './history/reducers';
import leads from './leads/reducers';
import profiles from './profile/reducers'; 
import resolves from './resolve/reducers'; 

export default combineReducers({
  authenticate,
  checks,
  runChecks,
  counters,
  users,
  suspiciousProfiles,
  profileChecks,
  flash,
  profileVerifications,
  checkVerifications,
  singleChecks,
  storage,
  userHistories,
  leads,
  profiles,
  resolves,
});



// WEBPACK FOOTER //
// ./src/redux/reducers.js